import type { SxProps, Theme } from "@mui/material/styles";

export const grid: SxProps<Theme> = (theme) => ({
  display: "grid",
  gridTemplateColumns: { xs: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
  gap: theme.spacing(2.5),
});
